import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'
import {type LineTone, LINE_TONE_CLASS} from '../../../../helpers/stack-entry-line-tone'

// Mirrors `get-effective-entry-line-class` but for the rebasing UI: each
// `RebaseState` maps to a Primer color "tone" that matches its status icon, and
// the vertical line segment below an entry's icon is drawn in that tone. Reuses
// the tone classes defined in `StackList.module.css`.

const REBASE_STATE_TONE: Record<RebaseState, LineTone> = {
  [RebaseState.Rebasing]: 'attention',
  [RebaseState.Rebased]: 'success',
  [RebaseState.MergeConflicts]: 'danger',
  [RebaseState.FailedToRebase]: 'danger',
  [RebaseState.Skipped]: 'default',
}

function tone(state?: RebaseState): LineTone {
  return state ? REBASE_STATE_TONE[state] : 'default'
}

// Returns the className for a rebasing entry's `NavList.Item` so its vertical
// line segment matches its rebase state.
export function getRebaseStateLineClass(state?: RebaseState): string {
  return LINE_TONE_CLASS[tone(state)]
}
